<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-select-all`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.607 33.293l-4.95 4.949-2.121-2.12a1 1 0 00-1.415 0l-1.414 1.413a1 1 0 000 1.415l4.243 4.242c.15.15.336.243.53.278l.118.014h.118a.996.996 0 00.648-.292l7.071-7.07a1 1 0 000-1.415l-1.414-1.414a1 1 0 00-1.414 0zM25 37a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H25zM14.607 19.293l-4.95 4.949-2.121-2.12a1 1 0 00-1.415 0l-1.414 1.413a1 1 0 000 1.415l4.243 4.242c.15.15.336.243.53.278l.118.014h.118a.996.996 0 00.648-.292l7.071-7.07a1 1 0 000-1.415l-1.414-1.414a1 1 0 00-1.414 0zM25 23a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H25zM14.607 5.464l-4.95 4.95-2.121-2.121a1 1 0 00-1.415 0L4.707 9.707a1 1 0 000 1.414l4.243 4.243c.15.15.336.243.53.277l.118.014h.118a.996.996 0 00.648-.291l7.071-7.071a1 1 0 000-1.414l-1.414-1.415a1 1 0 00-1.414 0zM25 9a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H25z"/></svg>
</template>
<script>

export default {
  name: 'IconSelectAll',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
